<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedOption" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold Success rate
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ selectedSuccess }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Success rate
    
    .pa-4.white
      .font-semibold.mb-3.text-sm {{ $t('filter_by') }} success rate
      y-select.mb-2(v-model="option" :items="options" item-text="name" item-value="id" small placeholder="Select success rate")
    
    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="option" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="!option") {{ $t('apply') }}


</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data: () => ({
    showMenu: false,
    key: 'success_count',
    option: null,
    selectedOption: null,
    options: [
      { id: 0, name: '0 of 5 (0%)' },
      { id: 20, name: '1 of 5 (20%)' },
      { id: 40, name: '2 of 5 (40%)' },
      { id: 60, name: '3 of 5 (60%)' },
      { id: 80, name: '4 of 5 (80%)' },
      { id: 100, name: '5 of 5 (100%)' },
    ],
  }),
  computed: {
    selectedSuccess () {
      return this.options.find(option => option.id === this.selectedOption)?.name ?? null
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.option = this.filter.value
          this.selectedOption = this.filter.value
        }
      }
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.selectedOption = null
      this.option = null
    },
    apply () {
      this.showMenu = false
      this.selectedOption = this.option
      const filter = { key: this.key, value: this.option }
      this.$emit('update:filter', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>